import { render } from "./ComponenteDemandaFrio.vue?vue&type=template&id=708ffd0f&scoped=true"
import script from "./ComponenteDemandaFrio.vue?vue&type=script&lang=js"
export * from "./ComponenteDemandaFrio.vue?vue&type=script&lang=js"

import "./ComponenteDemandaFrio.vue?vue&type=style&index=0&id=708ffd0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708ffd0f"]])

export default __exports__